import EsusView from 'components/esus/EsusView'

export default function FichaConsumoAlimentarView() {
  return <EsusView url='/pec/user/cds/consumoAlimentar' />
}
